import useApi, { ApiOptions } from '../base/useApi';
import InventoryDeletionDTO from '@src/adapters/dto/inventory/InventoryDeleteDTO';

interface Params {
  id: string;
}

interface Result {
  inventory: InventoryDeletionDTO;
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/inventory/for_deletion/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindInventoryForDeletionLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindInventoryForDeletionLazy;
